import script from "./Send.vue?vue&type=script&lang=ts&setup=true"
export * from "./Send.vue?vue&type=script&lang=ts&setup=true"

import "./Send.vue?vue&type=style&index=0&id=a3d24e9e&lang=less"

const __exports__ = script;

export default __exports__